import { render, staticRenderFns } from "./warrantyStyle.vue?vue&type=template&id=23078e96&scoped=true"
import script from "./warrantyStyle.vue?vue&type=script&lang=js"
export * from "./warrantyStyle.vue?vue&type=script&lang=js"
import style0 from "./warrantyStyle.vue?vue&type=style&index=0&id=23078e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23078e96",
  null
  
)

export default component.exports